import React, {useEffect} from 'react';

import { faHeartbeat, faWheelchair } from '@fortawesome/free-solid-svg-icons';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setCondition } from '../store/actions/profilActions';
import { useLabelValue } from '../utils/useLabelValue';
import { TextMenuItem } from '../components/Select/CustomMenuItem';
import { ConditionTypo } from '../components/Typography/ConditionTypography';
import { InputSelectWithOutIcon } from '../components/InputSelectWithOutIcon';

export const ConditionProfil = ({profil, isMobile, conditionValue, showInput}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const {setLabelCondition} = useLabelValue();
  
  const ConditionItem = props => {
    let {selected, label} = props;
  
    return (
      <TextMenuItem 
        active={selected ? 'true' : 'false'}
        {...props}>
        {label ?? props['data-value']}
      </TextMenuItem>
    );
  };

  const typeCondition = typeProfil => {
    switch (typeProfil) {
      case 'Marche': 
        return [
          'Forte endurance', 
          'Endurance normale', 
          'Marche difficilement'
        ];
      case 'Déficience visuelle':
        return [ 
          'Partielle (malvoyant)', 
          'Totale (non-voyant)'
        ];
      case 'Déficience motrice': 
        return [
          'Fauteuil roulant manuel', 
          'Fauteuil roulant électrique'
        ];
      case 'Déficience auditive' : 
        return [
          'Partielle (malentendant)', 
          'Totale (sourd)'
        ];
      case 'Déficience mentale' : 
        return [
          'Trouble intellectuel', 
          'Trouble psychique'
        ];
      default : return null;
    }
  };
  

  const textLabel = typeProfil => {
    switch (typeProfil) {
      case 'Déficience motrice':
        return t('form.condition-label-wheelchair');
      case 'Marche':
        return t('form.condition-label-walk');
      default : return 'Handicap';
    }
  };
  
  const iconLabel = typeProfil => {
    switch (typeProfil) {
      case 'Déficience motrice':
        return faWheelchair;
      default : return faHeartbeat;
    }
  };

  const renderValueCondition = condition => {
    return (
      <ConditionTypo>
        {setLabelCondition(condition)}
      </ConditionTypo>
    );
  };

  let listCondition = typeCondition(profil);
  const handleCondition = condition => 
    dispatch(setCondition(condition));

  useEffect(() => {
    if(!typeCondition(profil).includes(conditionValue)){
      dispatch(setCondition(typeCondition(profil)[1]));
    }
  }, [profil]);

  return (
    <>
      {showInput && 
        Array.isArray(listCondition) && listCondition?.length > 0 && (
        <InputSelectWithOutIcon
          isMobile={isMobile} 
          id='select-condition' 
          defaultValue={conditionValue} 
          icon={iconLabel(profil)} 
          label={textLabel(profil)} 
          htmlTag='condition' 
          value={conditionValue} 
          renderValue={() => renderValueCondition(conditionValue)}
          setValue={event => handleCondition(event.target.value)}>
          {listCondition?.map(condition => {
            return (
              <ConditionItem 
                key={condition} 
                label={setLabelCondition(condition)} 
                value={condition}
              >
                {condition}
              </ConditionItem>
            );
          })} 
        </InputSelectWithOutIcon>
      )
      }
    </>
  );
};